import { StyledDrawer as RDrawer } from "./style";

export default RDrawer;
